// Groups available dishes into parent with child variants.
// - Parent dish: dish.parentDishId === null
// - Child dish: dish.parentDishId !== null
// - If only child dishes come but each has parentDish, synthesize a parent
// - Ensure parent appears as the first option among childDishes when present

export const groupDishesByParentChild = (dishes = []) => {
  const parentDishesMap = new Map();
  const childDishes = [];

  dishes.forEach((dish) => {
    if (dish?.dish?.parentDishId) {
      childDishes.push(dish);
    } else {
      if (dish?.dish?.id && !parentDishesMap.has(dish.dish.id)) {
        parentDishesMap.set(dish.dish.id, {
          ...dish,
          childDishes: [],
        });
      }
    }
  });

  childDishes.forEach((child) => {
    const parentId = child.dish.parentDishId;
    if (!parentDishesMap.has(parentId) && child.dish.parentDish) {
      const parentFromChild = {
        id: `parent-${parentId}`,
        dishId: parentId,
        date: child.date,
        createdAt: child.createdAt,
        dish: {
          ...child.dish.parentDish,
          category: child.dish.category,
        },
      };
      parentDishesMap.set(parentId, {
        ...parentFromChild,
        childDishes: [],
      });
    }

    const parent = parentDishesMap.get(parentId);
    if (parent) parent.childDishes.push(child);
  });

  parentDishesMap.forEach((parent) => {
    const parentExistsInResponse = dishes.some(
      (dish) => dish?.dish?.id === parent?.dish?.id
    );
    if (parentExistsInResponse) {
      const parentAsChild = {
        id: parent.id,
        dishId: parent.dishId,
        date: parent.date,
        createdAt: parent.createdAt,
        dish: parent.dish,
      };
      parent.childDishes.unshift(parentAsChild);
    }
  });

  return Array.from(parentDishesMap.values());
};


